export default "__VITE_ASSET__B0Y30fv$__"